import React, { useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import google from "../../assets/images/other-pages/google.png";
import theyellow from "../../assets/images/other-pages/trypage.png";
import "./PatientReviews.css";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { Navigation, Keyboard } from "swiper/modules";
import EditCalendarIcon from "@mui/icons-material/EditCalendar";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import healthgrade from "../../assets/images/other-pages/healthg-removebg-preview.png";
import webmd from "../../assets/images/other-pages/webmd-removebg-preview.png";
import wellness from "../../assets/images/other-pages/wellness-removebg-preview.png";
import googleImg from "../../assets/images/other-pages/google-removebg-preview.png";
import theyellowImg from "../../assets/images/other-pages/yp-1-removebg-preview.png";
import Tilt from "react-parallax-tilt";
import { Rating } from "@mui/material";
const PatientReviews = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    }); // Scroll to the top when the component mounts
  }, []);
  const writeReview = [
    {
      id: 1,
      link: "https://www.healthgrades.com/group-directory/fl-florida/crystal-river",
      image: healthgrade,
    },
    {
      id: 2,
      link: "https://doctor.webmd.com/doctor/kamalesh-amin-9d9c5212-511c-4f60-91c6-60d3c9fd2417-overview",
      image: webmd,
    },
    {
      id: 3,
      link: "https://www.wellness.com/reviews/976490/citrus-diagnostic-center-radiologist?po=?catid=43",
      image: wellness,
    },
    {
      id: 4,
      link: "http://google.com/maps/place/Citrus+Diagnostic+Center/@28.9035885,-82.5933738,15z/data=!4m7!3m6!1s0x0:0xeb4dead7dc4f5402!8m2!3d28.9035885!4d-82.5933738!9m1!1b1",
      image: googleImg,
    },

    {
      id: 5,
      link: "https://www.yellowpages.com/crystal-river-fl/mip/citrus-diagnostic-center-9902913",
      image: theyellowImg,
    },
  ];
  const greviews = [
    {
      id: 1,
      name: "William H.",
      star: 5,
      image: google,
      description:
        "They were professional, polite, helpful and very understanding They were especially attentive to my special needs when getting my MRI from a power chair! 🙂",
    },
    {
      id: 2,
      name: "Roberta J.,",
      star: 5,
      image: google,
      description:
        "Scheduling was quick and easy. They have appointments available right away which makes getting the test done sooner. They are great.",
    },
    {
      id: 3,
      name: "Maria N.,",
      image: theyellow,
      star: 5,
      description:
        "Outstanding experience! While other facilities were telling me 3+ weeks to see me for my STAT order from my doctor Citrus Diagnostic saw me within 2 hours. A huge thank you to Felicia Jacobsen for getting me in so quickly! Very professional, friendly, caring staff and doctor! If I could give them more stars I would! I will definitely use this facility again!",
    },

    {
      id: 6,
      name: "Wealthy Vanlandingham",
      star: 4,
      image: google,
      description:
        "Just had the fastest appointment ever! Paperwork, mammogram & bone density test all in 40 minutes. Kristina the mammogram lady was great - very friendly & had warm hands : ) Agree that it's tough getting somebody to answer the phone so now we'll see how long it is to get results...",
    },
    {
      id: 7,
      name: "Julie Geer",
      star: 5,
      image: google,
      description:
        "Had mammogram. Very efficient. My technologist Kristina was amazing. She made me feel comfortable, and test did not hurt (last time I had to have one at different facility, I was bruised after). No pain during this one.",
    },
    {
      id: 8,
      name: "Susan Strong",
      star: 5,
      image: google,
      description:
        "Kristina is absolutely amazing! She is upbeat, personable, and has a great sense of humor. She made me feel comfortable during my exam.",
    },
    {
      id: 9,
      name: "Jessica",
      star: 4,
      image: google,
      description:
        "Everybody seems really nice and helpful but I was 20 minutes late to a appt and they made me reschedule. So don't be late. Also I got my mammogram here and they try to make you as comfortable as they can and I barely had to wait.",
    },
    {
      id: 10,
      name: "Franny Papaneri",
      star: 5,
      image: google,
      description:
        "I had a CT scan with contrast done. I was a little nervous about having it done. Niki was the technican. She was very nice and made me feel very comfortable about having test done. She explained everything she was going to do.",
    },
    {
      id: 11,
      name: "Khali Dragonfly",
      star: 5,
      image: google,
      description:
        "Christina the mammogram tech was wonderful! As my first time I was a bit nervous, she set me at ease, gave clear directions and the process was painless and as pleasant as it could possibly be.",
    },
    {
      id: 12,
      name: "Therese'",
      star: 5,
      image: google,
      description:
        "First off everyone there is awesome the scheduler worked my appointment in so I could do all my imaging the same day. Nikki who did my mammogram made the uncomfortable process less stressful. definitely recommend Citrus Diagnostic.",
    },
    {
      id: 13,
      name: "Stephen Clarke",
      star: 4,
      image: google,
      description:
        "No problem for me here, the waiting room was full but I only waited five minutes to get seen and I was a “walk in”. X-ray guy was pleasantly efficient as were the girls receiving patients. It was clean and smelled of nothing, perfect.",
    },
    {
      id: 14,
      name: "Kittie E",
      star: 5,
      image: google,
      description:
        "All staff personable & professional. Minimal wait time. Had mammo & a week later an ultrasound. Kaici was outstanding, knowledgeable, and compassionate. It is a busy office, but all seemed to run very smoothly.",
    },
    {
      id: 15,
      name: "lbfrog03",
      star: 4,
      image: google,
      description:
        "My Mother has been here many times and they all do a good job and care. This was the 2nd time with Kasey and she was awesome both times!! I highly recommend her for any artery ultrasound you may need done as well as all your needs at Citrus Diagnostic. We've never been disappointed and always feel cared for by all staff.",
    },
    {
      id: 16,
      name: "Liz Young",
      star: 5,
      image: google,
      description:
        "Kristina was my tech, she is awesome!!! Really made me feel comfortable with having my mammogram, she even went above and helped me with my next appointment for my ct scan.",
    },
    {
      id: 17,
      name: "Jane Peel",
      star: 5,
      image: google,
      description:
        "Kristina was so friendly and so funny. Made me feel so comfortable and relaxed. She did a great job. Everyone in the office was so nice and cheerful.",
    },
  ];
  return (
    <div className="pt-16 sm:pt-20 md:pt-24 lg:pt-[12.0625rem] text-white flex justify-center items-center flex-col  ">
      <div className="px-4 pb-8 pt-16 sm:px-6 sm:pt-10 md:px-8 md:pt-12 lg:px-10 flex xl:w-3/4 w-11/12  slider-wrapper overflow-hidden justify-center relative items-center flex-col lg:pt-16">
        <div className="text-center my-8 xl:my-16 ">
          <h1 className="text-white font-robout text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-[8.25rem] font-bold capitalize tracking-[-.04em] leading-tight">
            Patient Reviews
          </h1>
        </div>
        <div className="relative w-full flex justify-center">
          <Swiper
            loop={true}
            autoHeight={true}
            centeredSlides={true}
            slidesPerView={"auto"}
            autoplay={true}
            grabCursor={true}
            spaceBetween={50}
            pagination={{
              clickable: true,
            }}
            keyboard={{
              enabled: true,
            }}
            navigation={{
              nextEl: ".next-button",
              prevEl: ".prev-button",
            }}
            modules={[Navigation, Keyboard]}
            className="custom-swiper flex justify-center items-center mt-12"
          >
            {greviews.map((item, index) => (
              <SwiperSlide
                key={index}
                className="slide-card flex justify-center md:pt-16 py-8 relative "
              >
                <div className=" w-4/5 ">
                  <div className="flex flex-col justify-center lg:gap-2  gap-1 items-start overflow-y-auto lg:p-8 px-4">
                    <p className=" font-robout -mt-2 xl:text-3xl text-lg  2xl:leading-[1.2]">
                      {item.description}
                    </p>
                    <div className="flex md:justify-between justify-start md:flex-row flex-col w-full md:mt-8">
                      <div>
                        <h3 className="lg:text-3xl text-2xl capitalize  font-medium">
                          {item.name}
                        </h3>
                        <div className="mt-3">
                          <img src={`${item.image}`} className="w-36 " alt="" />
                        </div>
                      </div>
                      <div>
                        {" "}
                        <div className="mt-3">
                          <div className="mt-3 flex flex-row gap-2">
                            <Rating
                              name="dynamic-rating"
                              value={item.star || 0}
                              precision={0.5}
                              readOnly
                              size="large"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          <div className=" absolute inset-0 flex w-full  justify-between  items-center md:px-8 px-1 ">
            <button className="group  nav-button prev-button relative inline-flex justify-center items-center md:h-16 md:w-16 w-10 h-10 mt-3 z-10  rounded-full font-semibold text-black bg-transparent overflow-hidden">
              <span className="absolute inset-0 rounded-full bg-[#d78558] transition-transform duration-[1800ms] ease-[cubic-bezier(0.19,1,0.22,1)] scale-100 group-hover:scale-100">
                <span className="absolute left-1/2  -translate-x-1/2 aspect-square w-[max(200%,10rem)]">
                  <span className="absolute inset-0 rounded-full bg-[#a374ff] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                  <span className="absolute inset-0 rounded-full bg-[#17f1d1] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-100 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                  <span className="absolute inset-0 rounded-full bg-[#d78558] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-200 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                </span>
              </span>
              <span className="relative">
                <span className="block text-white group-hover:opacity-0  group-hover:-translate-y-[70%] transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                  <KeyboardBackspaceIcon />
                </span>
                <span className="absolute text-white  top-0 left-0  opacity-0 translate-y-[70%] text-center group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                  <KeyboardBackspaceIcon />
                </span>
              </span>
            </button>
            <button className="group  nav-button next-button relative inline-flex justify-center items-center md:h-16 md:w-16 w-10 h-10 mt-3 z-10  rounded-full font-semibold text-black bg-transparent overflow-hidden">
              <span className="absolute inset-0 rounded-full bg-[#d78558] transition-transform duration-[1800ms] ease-[cubic-bezier(0.19,1,0.22,1)] scale-100 group-hover:scale-100">
                <span className="absolute left-1/2 top-[-60%] -translate-x-1/2 aspect-square w-[max(200%,10rem)]">
                  <span className="absolute inset-0 rounded-full bg-[#a374ff] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                  <span className="absolute inset-0 rounded-full bg-[#17f1d1] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-100 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                  <span className="absolute inset-0 rounded-full bg-[#d78558] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-200 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                </span>
              </span>
              <span className="relative">
                <span className="block text-white group-hover:opacity-0 rotate-180  group-hover:-translate-y-[70%] transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                  <KeyboardBackspaceIcon />
                </span>
                <span className="absolute text-white  top-0 left-0  opacity-0 rotate-180 translate-y-[70%] text-center group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                  <KeyboardBackspaceIcon />
                </span>
              </span>
            </button>
          </div>
        </div>
      </div>
      <div className="my-16 flex justify-center items-center flex-col">
        <h2 className="text-white font-robout text-4xl sm:text-5xl md:text-6xl lg:text-7xl capitalize tracking-[-.04em] leading-tight">
          Leave a Review
        </h2>
        <div className="flex justify-center items-center pb-16">
          <div className=" mx-auto grid gap-8  grid-cols-1  justify-items-center sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 2xl:w-4/5 w-11/12 mt-28 px-4">
            {writeReview.map((item, index) => (
              <Tilt key={index}>
                <div className="relative group mb-2">
                  <div className="w-full p-4 rounded-3xl backdrop-blur-2xl bg-[#FEECE2]  shadow-xl overflow-hidden">
                    <div className=" my-4 h-full flex items-center justify-center">
                      <img
                        src={`${item.image}`}
                        alt=""
                        className="w-full h-full object-cover rounded-2xl duration-500 "
                      />
                    </div>
                    <a
                      target="_blank"
                      rel="noreferrer noopener "
                      href={`${item.link}`}
                      className=" relative inline-flex h-14 mt-6 w-full items-center rounded-full px-8  font-semibold text-white bg-transparent overflow-hidden"
                    >
                      <span className="absolute inset-0 rounded-full bg-[#fd6b6b] transition-transform duration-[1800ms] ease-[cubic-bezier(0.19,1,0.22,1)] scale-100 group-hover:scale-100">
                        <span className="absolute left-1/2 top-[-60%] -translate-x-1/2 aspect-square w-[max(200%,10rem)]">
                          <span className="absolute inset-0 rounded-full bg-[#17f1d1] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                          <span className="absolute inset-0 rounded-full bg-[#a374ff] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-100 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                          <span className="absolute inset-0 rounded-full bg-[#fd6b6b] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-200 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                        </span>
                      </span>

                      <span className="relative w-full text-center">
                        <span className="flex flex-row gap-2 justify-center  items-center group-hover:opacity-0 group-hover:-translate-y-[70%] transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                          Leave A Review
                        </span>
                        <span className="absolute left-0 w-full  top-0  opacity-0 translate-y-[70%] text-center group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                          Leave A Review
                        </span>
                      </span>
                    </a>
                  </div>
                </div>
              </Tilt>
            ))}
          </div>
        </div>
        <div
          data-aos="fade-up"
          data-aso-delay="400"
          className="text-left md:w-3/5 flex  justify-center md:items-start items-center flex-col w-11/12 my-16"
          id="pss"
        >
          <h2 className="text-[#d78558] sm:text-4xl font-robout text-[1.7rem] lg:mb-0 mb-4 font-black">
            Patient Feedback Form
          </h2>
          <p className="font-robout md:text-[1.35rem] text-xl font-medium md:text-left text-center text-white md:px-4 md:pt-6 pt-2">
            Please fill out the following feedback form, which will help us
            gather the information and improve our services to provide our
            patients with more effective treatment and provide them the best
            care possible:
          </p>
          <div className="grid  md:grid-cols-2 gap-3 pt-4 sm:p-4">
            <div className="flex justify-center items-center p-2">
              <a
                href="https://www.emailmeform.com/builder/form/bFA4tI8783"
                target="_blank"
                rel="noopener noreferrer"
              >
                {" "}
                <button className="group relative inline-flex h-14 mt-3 w-[256px] items-center rounded-full px-8 font-semibold text-white bg-transparent overflow-hidden">
                  <span className="absolute inset-0 rounded-full bg-[#d78558] transition-transform duration-[1800ms] ease-[cubic-bezier(0.19,1,0.22,1)] scale-100 group-hover:scale-100">
                    <span className="absolute left-1/2 top-[-60%] -translate-x-1/2 aspect-square w-[max(200%,10rem)]">
                      <span className="absolute inset-0 rounded-full bg-[#a374ff] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                      <span className="absolute inset-0 rounded-full bg-[#17f1d1] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-100 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                      <span className="absolute inset-0 rounded-full bg-[#d78558] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-200 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                    </span>
                  </span>

                  <span className="relative">
                    <span className="flex flex-row gap-2 justify-center ps-2 items-center group-hover:opacity-0 group-hover:-translate-y-[70%] transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                      <EditCalendarIcon /> Click here to begin
                    </span>
                    <span className="absolute flex flec-row gap-2 top-0 left-14 opacity-0 translate-y-[70%] text-center group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                      <OpenInNewIcon /> Visit
                    </span>
                  </span>
                </button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PatientReviews;
